import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface ExampleQuestionsProps {
  questions: string[];
  onQuestionClick: (question: string) => void;
}

export const ExampleQuestions: React.FC<ExampleQuestionsProps> = ({ questions, onQuestionClick }) => (
  <>
    <Typography sx={{ fontSize: '14px', color: '#4b5563' }}>
      Ask me anything about the COE Marketplace - plugins, products, access management, STS provisioning, and more!
    </Typography>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {questions.map((q, index) => (
        <Button
          key={index}
          onClick={() => onQuestionClick(q)}
          sx={{
            width: '100%',
            textAlign: 'left',
            justifyContent: 'flex-start',
            px: 2,
            py: 1.5,
            bgcolor: '#f9fafb',
            '&:hover': { bgcolor: '#f3f4f6' },
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            fontSize: '14px',
            color: '#374151',
            textTransform: 'none',
            fontWeight: 400,
          }}
        >
          {q}
        </Button>
      ))}
    </Box>
  </>
);
